import React, { useState, useRef, ReactNode } from 'react';
import { FaChevronRight } from "react-icons/fa6";

type AccordionProps = {
    title: ReactNode;
    content: ReactNode;
    theme: 'primary' | 'secondary' | 'accent';
    highlightWhenOpen?: boolean;
};

const themeClasses = {
    primary: {
        bg: 'bg-primary dark:bg-dark-primary',
        text: 'text-primary-contrast dark:text-dark-primary-contrast',
    },
    secondary: {
        bg: 'bg-secondary dark:bg-dark-secondary',
        text: 'text-secondary-contrast dark:text-dark-secondary-contrast',
    },
    accent: {
        bg: 'bg-accent dark:bg-dark-accent',
        text: 'text-accent-contrast dark:text-dark-accent-contrast',
    },
    background1: {
        bg: 'bg-background1 dark:bg-dark-background1',
        text: 'text-text1 dark:text-dark-text1',
    },
};

const Accordion: React.FC<AccordionProps> = ({ title, content, theme, highlightWhenOpen = false }) => {
    const [isOpen, setIsOpen] = useState(false);
    const contentRef = useRef<HTMLDivElement>(null);

    const toggleAccordion = () => {
        setIsOpen(!isOpen);
    };

    const headerClasses = `${isOpen && highlightWhenOpen ? themeClasses[theme].bg : themeClasses.background1.bg} ${
        isOpen && highlightWhenOpen ? themeClasses[theme].text : themeClasses.background1.text
    } p-4 cursor-pointer transition-colors duration-700`; // Slower transition for color

    return (
        <div className="border border-background2 dark:border-dark-background2 rounded-md overflow-hidden">
            <div className={headerClasses} onClick={toggleAccordion}>
                <div className='flex items-center gap-4'>
                    {title}
                    <FaChevronRight size={12} className={`ml-auto transition-transform duration-200 ${isOpen ? 'transform rotate-90' : ''}`} />
                </div>
            </div>
            <div
                ref={contentRef}
                className="transition-max-height duration-200 ease-in-out overflow-hidden bg-background1 text-text1 dark:text-dark-text1 dark:bg-dark-background1"
                style={{ maxHeight: isOpen ? contentRef.current?.scrollHeight : 0 }}
            >
                <div className="p-4 border-t border-background2 dark:border-dark-background2">
                    {content}
                </div>
            </div>
        </div>
    );
};

export default Accordion;